import PropTypes from "prop-types";
import GrowthLineChart from "./charts/GrowthLineChart";

function GrowthCard({ chart }) {
  return (
    <section className="sd-card sd-growth-card">
      <h3 className="sd-section-title">Growth</h3>
      <GrowthLineChart chart={chart} />
    </section>
  );
}

GrowthCard.propTypes = {
  chart: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default GrowthCard;
